export default __webpack_public_path__ + "img/school_med.f90b83c4.png";